<div class="popup-backdrop">

  <div class="gmail-popup">

    <!-- HEADER -->
    <div class="popup-header">
      <span>New Vessel</span>
      <span class="close-btn" (click)="onCancel()">✕</span>
    </div>

    <!-- BODY -->
    <div class="popup-body">
      <div class="icon">⚠️</div>

      <div class="text">
        <h3>Vessel not found</h3>
        <p>
          This vessel does not exist in the system.<br>
          Please verify the spelling or proceed to onboard.
        </p>
      </div>
    </div>

    <!-- ACTIONS -->
    <div class="popup-actions">
      <button class="cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="proceed-btn" (click)="onProceed()">Proceed Anyway</button>
    </div>

  </div>

</div>